var toSink = require('./sink');

var toSource = require('./source');

module.exports = function (duplex) {
  return {
    sink: toSink(duplex),
    source: toSource(duplex)
  };
};